exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer{padding:150px 0 100px}footer a,footer a:hover{text-decoration:none}.Footer__logo img{max-height:44px}.SocialNetworks__iconsWrapper{margin-left:30px}.SocialNetworks__icon img{height:40px;margin:0 5px}.FooterNav{margin:80px 0}.FooterNav__column{border-left:1px solid #000;padding-left:30px;margin-top:30px}.FooterNav__heading{color:#000;font-size:1.35rem}.FooterNav__list{margin:0;padding:0;list-style:none}.FooterNav__link{color:#a8a8a8;line-height:220%}.FooterNav__link:hover{color:#000}.Footer__credits{font-size:.8rem}.Footer__credits,.Footer__credits a{color:#000}", ""]);

// exports
